import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
//Redux
import { useSelector, useDispatch } from 'react-redux';
import { setCheckoutStep, setPaymentStatus, incrementAttempts, setShowError } from '../../actions/actionCreators';
import { useTranslation } from 'react-i18next';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import './Buttons.css';


const useStyles = makeStyles((theme) => ({
  root: {
    width: '40%',
    textTransform: 'none'
  },
  backButton: {
    marginRight: theme.spacing(1),
    textTransform: 'none',
    textDecoration: 'underline',
    marginBottom: '0.5rem',
    fontSize: '0.8rem'
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  nextBtn: {
    textTransform: 'none',
    minWidth: 200,
    fontSize: '1.2rem',
  },
  nextBtnWhite: {
    textTransform: 'none',
    minWidth: 200,
    fontSize: '1.2rem',
    color: 'white',
  },
}));

export default function Buttons() {
  const frontConfig = useSelector(state => state.frontConfigReducer);
  const classes = useStyles({ color: frontConfig.color });
  const matches = useMediaQuery("(max-width:599px)");

  const navigationStep = useSelector(state => state.navigationReducer);
  const canContinue = useSelector(state => state.navigationReducer.canContinue);
  const loading = useSelector(state => state.navigationReducer.loading);
  const dispatch = useDispatch();

  const defaultContinueText = (navigationStep.checkoutStep === 3) ? 'Confirm' : 'Continue to shipping';

  const [btnBgColor, setBtnBgColor] = useState('orange');
  const [continueText, setContinueText] = useState(defaultContinueText);
  const [backText, setBackText] = useState('Back');
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (canContinue) {
      setBtnBgColor('orange');
    } else {
      setBtnBgColor('grey');
    }
  }, [navigationStep.canContinue, navigationStep.checkoutStep])

  useEffect(() => {
    const step = navigationStep.checkoutStep;
    updateContinueText(step);
    updateBackText(step);
  }, [navigationStep])

  const handleConfirm = () => {
    dispatch(setPaymentStatus([{ fieldToUpdate: 'startPaymentProcessing', value: true }]));
  }

  const handleNext = () => {
    //setActiveStep((prevActiveStep) => prevActiveStep + 1);
    if (canContinue && navigationStep.checkoutStep < 3) {
      let newStep = navigationStep.checkoutStep + 1;
      dispatch(setCheckoutStep(newStep));
      updateContinueText(newStep);
      updateBackText(newStep);
    } else if (canContinue && navigationStep.checkoutStep === 3) {
      handleConfirm();
    } else {
      dispatch(incrementAttempts());
    }

    if (!canContinue && navigationStep.checkoutStep === 2) {
      dispatch(setShowError({ showError: true, errorText: 'Please select a date and time window' }));
    }
  };

  const handleBack = () => {
    //setActiveStep((prevActiveStep) => prevActiveStep - 1);
    if (navigationStep.checkoutStep > 1) {
      let newStep = navigationStep.checkoutStep - 1
      dispatch(setCheckoutStep(newStep));

    }
  };


  return (
    <div className="ButtonsInnerContainer">
      {
        navigationStep.checkoutStep === 1 ? null :
          <Button
            // disabled={!canContinue}
            variant={"text"}
            className={classes.backButton}
            onClick={handleBack}
          >
            {t(backText)}
          </Button>
      }
      {
        loading ? null :
          <Button
            disabled={!canContinue}
            className={navigationStep.checkoutStep >= 2 && matches ? classes.nextBtn2 : canContinue ? classes.nextBtnWhite : classes.nextBtn}
            variant={"contained"}
            color={"primary"}
            style={{ textTransform: 'none' }}
            onClick={handleNext}>
            {t(continueText)}
          </Button>
      }
    </div>
  )

  function updateBackText(step) {
    //console.log(step);
    switch (step) {
      case 1:
        setBackText('');
        break;
      case 2:
        setBackText('Update shipping address');
        break;
      case 3:
        setBackText('Update schedule');
        break;

      default:
        setBackText('Back');
        break;
    }
  }

  function updateContinueText(step) {
    //console.log(step);
    switch (step) {
      case 1:
        setContinueText('Continue to shipping');
        break;
      case 2:
        setContinueText('Continue to payment');
        break;
      case 3:
        setContinueText('Confirm');
        break;

      default:
        setContinueText('Next');
        break;
    }
  }
}
